export function throttle(fun: () => void, delay = 300) {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return [
    () => {
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          fun();
        }, delay);
      }
    },
    () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    },
  ];
}
